export const JobDetailsReducer = (state = {}, action) => {
    switch (action?.type) {
        case "FULL_JOB_DETAILS":
            return {
                ...state,
                jobDetails: action?.payload,
            };

        default:
            return state;
    }
};
